import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const previewAgentPromptTemplate = unaryRpc({
  name: "previewAgentPromptTemplate",
  input: z.object({
    agentName: z.string(),
    teamId: z.string(),
    testPromptTemplate: z.string(),
  }),
  output: z.object({
    compiledPrompt: z.string(),
    error: z.string().optional(),
  }),
});
